export function combinedCauseNumber(student = {}) {
  return student.cause_number || '';
}
